const STATUS_LABELS = {
    'dcp-on-request': 'Available to Order (dcp-on-request)',
};

export const formatStatusValue = (key, value) => {
    if ((key === 'status' || key === 'statusWorkflow') && STATUS_LABELS[value]) {
        return STATUS_LABELS[value];
    }
    return null;
};
